"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var LinkWrapper_1 = __importDefault(require("../LinkWrapper"));
var next_intl_1 = require("next-intl");
var ui_components_1 = require("@l2p/ui-components");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var image_1 = __importDefault(require("next/image"));
var navigation_1 = require("next/navigation");
var Winner = function (_a) {
    var title = _a.title, gameId = _a.gameId, playerName = _a.playerName, imageUrl = _a.imageUrl, prize = _a.prize, gameCardPlaceholder = _a.gameCardPlaceholder, slug = _a.slug;
    var _b = (0, react_1.useState)(gameCardPlaceholder), imageSrc = _b[0], setImageSrc = _b[1];
    var t = (0, next_intl_1.useTranslations)('translation');
    var push = (0, navigation_1.useRouter)().push;
    var openGameInfo = (0, react_1.useCallback)(function () { return push("modal=".concat(gameId)); }, [gameId, push]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.winBlock },
        react_1.default.createElement(LinkWrapper_1.default, { slug: slug, WrappedComponent: function (_a) {
                var onClick = _a.onClick;
                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.imageContainer, onClick: onClick },
                    react_1.default.createElement(image_1.default, { width: 120, className: styles_module_scss_1.default.gameCardImage, height: 70, src: imageSrc, onLoad: function () {
                            setImageSrc(imageUrl);
                        }, alt: title, placeholder: gameCardPlaceholder, onClick: onClick })));
            }, openInfoModal: openGameInfo }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.winContent },
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", { className: styles_module_scss_1.default.playerName }, playerName)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.prize }, prize),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.inGame },
                react_1.default.createElement(LinkWrapper_1.default, { slug: slug, WrappedComponent: function (_a) {
                        var onClick = _a.onClick;
                        return (react_1.default.createElement("div", { onClick: onClick },
                            t('in'),
                            " ",
                            title));
                    }, openInfoModal: openGameInfo })),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                react_1.default.createElement(LinkWrapper_1.default, { slug: slug, WrappedComponent: function () { return (react_1.default.createElement(ui_components_1.PlayNowBtn, { typeButton: "desktop", size: "small" })); }, openInfoModal: openGameInfo })))));
};
exports.default = react_1.default.memo(Winner);
